import { setFavorite } from '../../../shared/actions/newbuilding';
import {
  fetchDeleteOfferFromFavorites,
  IDeleteOfferFromFavoritesRequest,
} from '../../../shared/repositories/favorites/v1/delete-offer-from-favorites';
import { IFavoriteActionTypes } from '../../../shared/types/analytics/favorite';
import { TThunkAction } from '../../../shared/types/redux/thunk';
import { trackRemoveFromFavorites } from './tracking';

export function removeFavorite(
  gaLabel: string,
  parameters: IDeleteOfferFromFavoritesRequest,
  eventActions?: IFavoriteActionTypes,
): TThunkAction {
  return async (dispatch, getState, { httpApi, logger }) => {
    dispatch(setFavorite(false));
    const newbuildingId = parameters.entityId;

    trackRemoveFromFavorites(gaLabel, newbuildingId, eventActions && eventActions.remove);

    try {
      await fetchDeleteOfferFromFavorites({ httpApi, parameters });
    } catch (error) {
      logger.error(error, {
        newbuildingId,
        domain: 'removeFavorite',
      });

      dispatch(setFavorite(true));
    }
  };
}
